<template>
    <main class="request-code">
        <header class="request-code__header">
            <h1>Hier Spendencode beantragen und Gutes tun</h1>
            <p class="intro" v-if="!codeRequested">
                Sie möchten ein Projekt Ihrer Wahl fördern? Das geht mit einem Spendencode unserer Aktion. Über untenstehendes Formular können Sie direkt einen solchen Code anfordern. Dies ist alle 30 Tage möglich. Also, kommen Sie bald wieder vorbei und holen Sie sich einen neuen Spendencode!
            </p>
            <p id="error-desc-request-code" style="font-weight: bold; color: #d11212; text-align: center;" v-show="this.$v.$error">
                Bitte füllen Sie alle rot markierten Felder aus.
            </p>
            <p id="error-desc-request-code-unknown" style="font-weight: bold; color: #d11212; text-align: center;" v-show="errors.unknown">
                Ein unbekannter Fehler ist aufgetreten.
            </p>
        </header>

         <div v-if="!codeRequested" class="submit-project__form">
            <div class="submit-project__form-inner">
                <form ref="form" @submit.prevent.stop>

                    <div class="form-block form-block--centered form-block--description-right">
                        <label class="form-block__label">Ihre Daten *</label>
                        <div class="form-row">
                            <input-custom
                                v-model="$v.form.email.$model"
                                :error="$v.form.email.$error"
                                type="email"
                                class="col-12 col-lg-12"
                                aria-label="E-Mail Adresse"
                            >
                                E-Mail Adresse
                            </input-custom>
                        </div>
                    </div>

                    <div class="form-block form-block--centered form-block--description-right">
                        <div class="form-group">
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    id="datenschutz"
                                    class="form-check-input"
                                    v-model="$v.form.datenschutz.$model"
                                    :class="{'is-invalid': $v.form.datenschutz.$error}"
                                >
                                <label for="datenschutz" class="form-check-label">Ich stimme den <router-link target="_blank" to="/datenschutz">Datenschutzbestimmungen</router-link> zu.</label>
                            </div>
                        </div>
                    </div>

                    <div class="form-block form-block--centered">
                        <div class="form-group">
                            <button
                                class="btn bnt--xl btn--blue"
                                @click="requestCode"
                            >
                                Jetzt Code anfordern
                            </button>
                        </div>
                    </div>

                </form>
            </div>
         </div>

        <div v-if="codeRequested && !errors.noCodesLeft && !errors.codePerUserLimitExceeded && !errors.unknown" id="request-code__created" class="request-code__created">
            <div class="request-code__created-inner">
                <div class="request-code__created-feedback">
                    <h2>
                        <span class="mdi mdi-check"></span>
                        Glückwunsch!
                    </h2>
                    <p>
                        Ihre Beantragung eines Spendencodes für die Aktion Velbert zeigt Herz war erfolgreich. Den Spendencode haben wir Ihnen per E-Mail zugeschickt. Hinter dem Code verbergen sich vier Förderherzen:
                        Unterstützen Sie damit auf unserer Website soziale Projekte, die dem Gemeinwohl Velberts dienen.
                        Gehen Sie direkt auf die Aktionsseite und lösen Sie Ihren Code ein - umso schneller wird das Projekt Wirklichkeit.
                        Und: Machen Sie Familie, Freunde und Kollegen auf das Projekt Ihrer Wahl aufmerksam. Einfach über die Aktionsseite oder
                        die <a href="https://www.facebook.com/StadtwerkeVelbert/" target="_blank" rel="noopener">Facebookseite</a> der Stadtwerke Ihr Herzensprojekt teilen. Gemeinsam macht helfen nochmal mehr Spaß.
                    </p>
                    <div class="form-block form-block--centered">
                        <div class="form-group">
                            <router-link :to="{name: 'PageStart'}">
                                <button
                                    class="btn bnt--xl btn--blue"
                                >
                                    Zurück
                                </button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="codeRequested && errors.noCodesLeft"  id="request-code__no-codes-left" class="request-code__created">
            <div class="request-code__created-inner">
                <div class="request-code__created-feedback">
                    <h2>
                        <span class="mdi mdi-close"></span>
                        Alle verfügbaren Spendencodes bereits vergeben
                    </h2>
                    <p>
                        Es tut uns leid - alle verfügbaren Spendencodes dieser Förderrunde sind leider schon vergeben.
                        Aber besuchen Sie uns auf <a href="https://www.facebook.com/StadtwerkeVelbert/" target="_blank" rel="noopener">Facebook</a> oder auf unserer Aktionsinternetseite, dann erfahren
                        Sie schnellstmöglich, wann wir wieder Spendencodes zur Verfügung stellen und Sie damit Gutes tun können. Danke, dass Sie Herz zeigen!
                    </p>
                </div>
                <div class="form-block form-block--centered">
                    <div class="form-group">
                        <router-link :to="{name: 'PageStart'}">
                            <button
                                class="btn bnt--xl btn--blue"
                            >
                                Zurück
                            </button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="codeRequested && errors.codePerUserLimitExceeded"  id="request-code__code-per-user-exceeded" class="request-code__created">
            <div class="request-code__created-inner">
                <div class="request-code__created-feedback">
                    <h2>
                        <span class="mdi mdi-close"></span>
                        Code bereits angefordert
                    </h2>
                    <p>
                        Nach unseren Unterlagen haben Sie bereits einen Code angefordert. Leider können wir Ihnen pro Monat nur einen Code schicken.<br>
                        Weitere Informationen finden Sie in den <router-link :to="{name: 'ParticipationTerms'}">Teilnahmebedingungen</router-link>. Besuchen Sie uns auch auf <a href="https://www.facebook.com/StadtwerkeVelbert/" target="_blank" rel="noopener">Facebook</a> oder auf unserer Aktionsinternetseite, dort erfahren Sie regelmäßig Neuigkeiten.<br>
                        Danke, dass Sie Herz zeigen!
                    </p>
                </div>
                <div class="form-block form-block--centered">
                    <div class="form-group">
                        <router-link :to="{name: 'PageStart'}">
                            <button
                                class="btn bnt--xl btn--blue"
                            >
                                Zurück
                            </button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import VueScrollTo from 'vue-scrollto'

import { validationMixin } from 'vuelidate'
import { required, email, sameAs } from 'vuelidate/lib/validators'
import InputCustom from '@/elements/InputCustom'
import TextareaCustom from '@/elements/TextareaCustom'
import SelectInput from '@/elements/SelectInput'

import resources from '@/resources'

export default {
    name: 'RequestCode',

    mixins: [
        validationMixin
    ],

    components: {
        InputCustom,
        TextareaCustom,
        SelectInput
    },

    data () {
        return {
            error: false,
            codeRequested: false,
            errors: {
                noCodesLeft: false,
                codePerUserLimitExceeded: false,
                unknown: false
            },
            form: {
                email: '',
                datenschutz: false
            }
        }
    },

    validations: {
        form: {
            email: {
                required,
                email: email()
            },
            datenschutz: {
                required,
                sameAs: sameAs(() => true)
            }
        }
    },

    methods: {
        requestCode () {
            // Make sure validation did trigger
            this.$v.$touch()
            // Check validation stats
            if (this.$v.$invalid) {
                return this.scrollTo('#error-desc-request-code')
            }

            // Build form data
            const formData = new FormData()
            formData.set('email', this.form.email)
            formData.set('dsgvo', 1)

            resources.post('codeRequests', formData, {headers: {'Content-Type': 'multipart/form-data'}})
                .then(response => {
                    console.log(response)
                    this.codeRequested = true
                    this.scrollTo('#error-desc-request-code')
                })
                .catch(error => {
                    console.log(error.response)
                    this.codeRequested = true

                    if (error.response.status !== 422) {
                        this.errors.unknown = true
                        return this.scrollTo('#error-desc-request-code-unknown')
                    }

                    switch (error.response.data.result_type) {
                    case 'b':
                        this.errors.codePerUserLimitExceeded = true
                        this.scrollTo('#request-code__code-per-user-exceeded')
                        break
                    case 'f':
                        this.errors.noCodesLeft = true
                        this.scrollTo('#request-code__no-codes-left')
                        break
                    default:
                        this.errors.unknown = true
                        this.scrollTo('#error-desc-request-code-unknown')
                    }
                })
        },

        scrollTo (selector) {
            const options = {
                container: 'body',
                easing: 'ease-out',
                offset: -100,
                force: true
            }

            this.$nextTick().then(() => {
                VueScrollTo.scrollTo(selector, 500, options)
            })
        }
    }
}

</script>

<style>
.form-check label a {
    color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/RequestCode.vue